import http from "../utils/axios";

// 获取产品分类 - 筛选用接口
export const getProductCate = data => {
  return http({
    url: "/api/product/getProductCate", // 接口
    method: "post",
    data: data
  });
};

// 获取保司信息 - 筛选用接口
export const getCompany = data => {
  return http({
    url: "/api/company/getCompany", // 接口
    method: "post",
    data: data
  });
};
// 文件上传，基础上传
export const upload = data => {
  return http({
    url: "/api/upload/upload", // 接口
    method: "post",
    data: data
  });
};
// 识别营业执照信息接口
export const businessLicenseIdentification = data => {
  return http({
    url: "/api/common/businessLicenseIdentification", // 接口
    method: "post",
    data: data
  });
};

// 身份证识别接口
export const idCardIdentification = data => {
  return http({
    url: "/api/common/idCardIdentification", // 接口
    method: "post",
    data: data
  });
};
// 修改账号密码接口
export const changePassword = data => {
  return http({
    url: "/api/admin/changePassword", // 接口
    method: "post",
    data: data
  });
};
// 下载发票
export const getBillFile = data => {
  return http({
    url: "/api/order/getBillFile", // 接口
    method: "post",
    data: data
  });
};
// 下载保单
export const getPolicyFile = data => {
  return http({
    url: "api/order/getPolicyFile", // 接口
    method: "post",
    data: data
  });
};
